import { SET_BET_INFO } from './types';
export var setBetInfo = function setBetInfo(value) {
  return {
    type: SET_BET_INFO,
    payload: value
  };
};